import { StockType } from 'global/Securities/types/stockType';
import {
  Expiry,
  OrderAction,
  OrderStatus,
} from 'global/Securities/types/transaction';
import { clevertapEvent } from 'utils/clevertap';

const orderActionValue = {
  [OrderAction.Buy]: 'Buy',
  [OrderAction.Sell]: 'Sell',
};

const symbolTypeValue = {
  [StockType.Right]: 'Right',
  [StockType.Waran]: 'Warrant',
  [StockType.Saham]: 'Normal',
};

const expiryValue = {
  [Expiry.GoodForDay]: 'Good for day',
  [Expiry.GoodTillCancelled]: 'Good till canceled',
};

const statusValue = {
  [OrderStatus.Open]: 'Open',
  [OrderStatus.Partial]: 'Partial',
  [OrderStatus.Match]: 'Match',
  [OrderStatus.Withdrawn]: 'Withdrawn',
  [OrderStatus.Amended]: 'Amended',
  [OrderStatus.Rejected]: 'Rejected',
};

// Views
export const trackOrderViewed = () => {
  clevertapEvent('Share Trade Order Viewed');
};

export const trackTradeSharedViewed = () => {
  clevertapEvent('Trade Shared Viewed');
};

export const trackOrderShareSelected = (type: OrderAction, symbol: string) => {
  const action = orderActionValue[type];
  clevertapEvent(`${action} Order Share Selected`, {
    Action: `${action} Order Share Selected`,
    Symbol: symbol,
  });
};

// Actions
export const trackOrderDetailShareSelected = (
  type: OrderAction,
  orderId: string,
  symbol: string,
  symbolType: StockType,
  expiry: Expiry,
  rejectReason: string,
  status: OrderStatus,
) => {
  const action = orderActionValue[type];
  clevertapEvent(`${action} Order Detail Share Selected`, {
    Action: `${action} Order Detail Share Selected`,
    'Order ID': orderId,
    Symbol: symbol,
    'Symbol Type': symbolTypeValue[symbolType] || 'Normal',
    Expiry: expiryValue[expiry],
    'Reject Reason': rejectReason,
    Status: statusValue[status],
  });
};

export const trackShareSelected = (symbol: string, isAddAutoShare: boolean) => {
  clevertapEvent('Share Trade Action', {
    Action: 'Share Selected',
    Symbol: symbol,
    'Add Auto Share': isAddAutoShare,
  });
};

export const trackDoneSelected = (symbol: string) => {
  clevertapEvent('Share Trade Action', {
    Action: 'Done Selected',
    Symbol: symbol,
  });
};
